import { c as _c } from "react/compiler-runtime";
import { useToast } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useBrowserNotifications, { type BrowserNotificationPermission } from '@/hooks/use-browser-notifications';
const useEnableNotifications = () => {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "floatingChat.notifications"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t0);
  const {
    toast
  } = useToast();
  const {
    requestPermission
  } = useBrowserNotifications();
  let t1;
  if ($[1] !== t || $[2] !== toast) {
    t1 = () => {
      toast({
        title: t(_temp),
        description: t(_temp2)
      });
    };
    $[1] = t;
    $[2] = toast;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const showEnabledToast = t1;
  let t2;
  if ($[4] !== requestPermission || $[5] !== showEnabledToast) {
    const enable = async () => {
      const result = await requestPermission();
      if (result === "granted") {
        showEnabledToast();
      }
      return result;
    };
    t2 = {
      enable
    };
    $[4] = requestPermission;
    $[5] = showEnabledToast;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default useEnableNotifications;
function _temp($) {
  return $.enabledToast.title;
}
function _temp2($_0) {
  return $_0.enabledToast.description;
}